import { IConfig } from '@cian/config/shared';
import { EPromoType, IPromoInfoSchema } from '../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';
import { getCianMortgagePromoUrl } from '../../../utils/config';

export const getMortgagePartnerLink = (promo: IPromoInfoSchema | null, config: IConfig) => {
  if (promo?.bank?.isPartner && promo?.promoType !== EPromoType.MaternalCapital) {
    return getCianMortgagePromoUrl(config);
  }

  return null;
};
